var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMigration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 23.95,
    y1: 44.05,
    x2: 14.05,
    y2: 53.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8da2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80c341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 21.12,
    y1: 46.88,
    x2: 16.88,
    y2: 51.12,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 65.9,
    y1: 6.29,
    x2: 11.9,
    y2: 60.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 33.71,
    y1: 8.29,
    x2: 32.29,
    y2: 9.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 37.71,
    y1: 8.29,
    x2: 36.29,
    y2: 9.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 41.71,
    y1: 8.29,
    x2: 40.29,
    y2: 9.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 57.71,
    y1: 16.29,
    x2: 56.29,
    y2: 17.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 53.71,
    y1: 16.29,
    x2: 52.29,
    y2: 17.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 49.71,
    y1: 16.29,
    x2: 48.29,
    y2: 17.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 33.71,
    y1: 24.29,
    x2: 32.29,
    y2: 25.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 37.71,
    y1: 24.29,
    x2: 36.29,
    y2: 25.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 41.71,
    y1: 24.29,
    x2: 40.29,
    y2: 25.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 57.71,
    y1: 32.29,
    x2: 56.29,
    y2: 33.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 53.71,
    y1: 32.29,
    x2: 52.29,
    y2: 33.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 49.71,
    y1: 32.29,
    x2: 48.29,
    y2: 33.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 58,
    y1: 40,
    x2: 50,
    y2: 48,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 48,
    y1: 40,
    x2: 40,
    y2: 48,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 10.7,
    y1: 4.9,
    x2: 1.3,
    y2: 14.3,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 18.7,
    y1: 5.7,
    x2: 9.3,
    y2: 15.1,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 26.7,
    y1: 4.9,
    x2: 17.3,
    y2: 14.3,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 17.67,
    y1: 23.67,
    x2: 9.67,
    y2: 31.67,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 42a7 7 0 107 7 7 7 0 00-7-7zm0 12a5 5 0 115-5 5 5 0 01-5 5z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 46a3 3 0 103 3 3 3 0 00-3-3zm0 4a1 1 0 111-1 1 1 0 01-1 1z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 4.76L59.62 0H30.38L28 4.76V25.4a12 12 0 00-21.84 4.65A7 7 0 007 44h2a1 1 0 010 .59c-.05.13-.11.26-.16.4a1 1 0 01-.64.59A3.07 3.07 0 006 48.5v1a3.07 3.07 0 002.12 2.92 1 1 0 01.64.6l.16.39a1 1 0 010 .87 3.05 3.05 0 00.57 3.56l.7.71a3.07 3.07 0 003.56.56 1 1 0 01.87 0l.4.16a1 1 0 01.59.64A3.07 3.07 0 0018.5 62h1a3.07 3.07 0 002.92-2.12 1 1 0 01.6-.64l.39-.16a1 1 0 01.87 0 3.05 3.05 0 003.56-.57l.71-.7a3.07 3.07 0 00.56-3.56 1 1 0 010-.87c.05-.13.11-.26.16-.4a1 1 0 01.64-.59 3 3 0 00.83-.42H62zM37.92 36A7 7 0 0031 30a6.76 6.76 0 00-1 .09V30h30v6zM30 28v-6h30v6zm0-8v-6h30v6zm0-8V6h30v6zM58.38 2l1 2H30.62l1-2zM2 37a5 5 0 014.94-5H8l.09-.91a10 10 0 0119.91.33l.08 1.33 1.26-.45A4.94 4.94 0 0131 32a5 5 0 010 10h-1.58a3 3 0 00-.88-1.84l-.7-.7a3 3 0 00-3.56-.57 1 1 0 01-.87 0l-.4-.16a1 1 0 01-.59-.64A3.07 3.07 0 0019.5 36h-1a3.07 3.07 0 00-2.92 2.12 1 1 0 01-.6.64l-.39.16a1 1 0 01-.87 0 3.05 3.05 0 00-3.56.57l-.71.7A3.08 3.08 0 008.58 42H7a5 5 0 01-5-5zm28 12.5a1.08 1.08 0 01-.74 1 3 3 0 00-1.89 1.77c0 .11-.08.21-.13.32a3 3 0 00.09 2.57 1.08 1.08 0 01-.2 1.25l-.7.7a1.08 1.08 0 01-1.25.2 3 3 0 00-2.57-.09l-.32.13a3 3 0 00-1.77 1.89 1.08 1.08 0 01-1 .74h-1a1.08 1.08 0 01-1-.74 3 3 0 00-1.77-1.89l-.32-.13a3 3 0 00-1.22-.22 3.09 3.09 0 00-1.39.33 1.08 1.08 0 01-1.25-.2l-.7-.7a1.08 1.08 0 01-.2-1.25 3 3 0 00.09-2.57c0-.11-.09-.21-.13-.32a3 3 0 00-1.89-1.77 1.08 1.08 0 01-.74-1v-1a1.08 1.08 0 01.74-1 3 3 0 001.89-1.77c0-.11.08-.21.13-.32a3 3 0 00-.09-2.57 1.08 1.08 0 01.2-1.25l.7-.7a1.08 1.08 0 011.25-.2 3 3 0 002.57.09l.32-.13a3 3 0 001.77-1.89 1.08 1.08 0 011-.74h1a1.08 1.08 0 011 .74 3 3 0 001.77 1.89l.32.13a3 3 0 002.57-.09 1.08 1.08 0 011.25.2l.7.7a1.08 1.08 0 01.2 1.25 3 3 0 00-.09 2.57c.05.11.09.21.13.32a3 3 0 001.89 1.77 1.08 1.08 0 01.74 1zm2 .5a2.74 2.74 0 000-.5v-1a3.07 3.07 0 00-2.12-2.92 1 1 0 01-.64-.6l-.16-.39A1 1 0 0129 44h2a7 7 0 006.92-6H60v12z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 9,
    r: 1,
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 9,
    r: 1,
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 9,
    r: 1,
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 17,
    r: 1,
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 17,
    r: 1,
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 17,
    r: 1,
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 25,
    r: 1,
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 25,
    r: 1,
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 25,
    r: 1,
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 33,
    r: 1,
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 33,
    r: 1,
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 33,
    r: 1,
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 48h8v-8h-8zm2-6h4v4h-4z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 48h8v-8h-8zm2-6h4v4h-4z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M5 5.3V18h2V5.3l2.17 3.25 1.66-1.1L6 .2 1.17 7.45l1.66 1.1L5 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M10.83 11.45l-1.66 1.1L14 19.8l4.83-7.25-1.66-1.1L15 14.7V2h-2v12.7l-2.17-3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M21 5.3V18h2V5.3l2.17 3.25 1.66-1.1L22 .2l-4.83 7.25 1.66 1.1L21 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 26v-2a8 8 0 00-8 8h2a6 6 0 016-6z",
    fill: "url(#u)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigration);
export default __webpack_public_path__ + "static/media/migration.6832b125ff0a39766e510a7bb12ff92e.svg";
export { ForwardRef as ReactComponent };